// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Common = require("../utils/Common.res.js");
var MM_context = require("../mm-utils/MM_context.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var MM_comment_parser = require("../mm-utils/MM_comment_parser.res.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");

function propsAreSame(a, b) {
  if (a.settings === b.settings && a.ctx === b.ctx && a.symColors === b.symColors) {
    return a.text === b.text;
  } else {
    return false;
  }
}

var make = React.memo((function (param) {
        var openFrameExplorer = param.openFrameExplorer;
        var symColors = param.symColors;
        var ctx = param.ctx;
        var settings = param.settings;
        var textParts = MM_comment_parser.splitCommentIntoParts(param.text);
        var getFrmLabelBkgColor = function (label) {
          var frame = MM_context.getFrame(ctx, label);
          if (frame !== undefined) {
            return MM_react_common.getFrmLabelBkgColor(frame, settings);
          }
          
        };
        return textParts.map(function (part, idx) {
                    switch (part.TAG) {
                      case "Text" :
                          return part._0;
                      case "MathMode" :
                          var key = idx.toString();
                          var expr = part._0;
                          return React.createElement("span", {
                                      key: key,
                                      style: {
                                        fontFamily: "monospace"
                                      }
                                    }, Common.getSpaceSeparatedValuesAsArray(expr).map(function (sym, idx) {
                                          var color = Belt_HashMapString.get(symColors, sym);
                                          var match = color !== undefined ? [
                                              color,
                                              "bold"
                                            ] : [
                                              "black",
                                              "normal"
                                            ];
                                          return React.createElement("span", {
                                                      key: sym + "$" + idx.toString(),
                                                      style: {
                                                        color: match[0],
                                                        fontSize: "1.3em",
                                                        fontWeight: match[1]
                                                      }
                                                    }, (
                                                      idx > 0 ? " " : ""
                                                    ) + sym);
                                        }));
                      case "LabelMode" :
                          var key$1 = idx.toString();
                          var label = part._0;
                          var match = MM_context.getTokenType(ctx, label);
                          var exit = 0;
                          if (match !== undefined) {
                            switch (match) {
                              case "A" :
                              case "P" :
                                  exit = 1;
                                  break;
                              default:
                                exit = 2;
                            }
                          } else {
                            exit = 2;
                          }
                          switch (exit) {
                            case 1 :
                                var tmp = {
                                  color: "blue",
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                  borderRadius: "3px"
                                };
                                var tmp$1 = getFrmLabelBkgColor(label);
                                if (tmp$1 !== undefined) {
                                  tmp.backgroundColor = tmp$1;
                                }
                                return React.createElement("span", {
                                            key: key$1,
                                            style: tmp,
                                            onClick: MM_react_common.clickHnd(undefined, undefined, undefined, undefined, (function () {
                                                    openFrameExplorer(label);
                                                  }))
                                          }, label);
                            case 2 :
                                if (label.startsWith("http:") || label.startsWith("https:")) {
                                  return React.createElement("a", {
                                              key: key$1,
                                              style: {
                                                color: "blue",
                                                cursor: "pointer",
                                                textDecoration: "underline"
                                              },
                                              href: label,
                                              target: "_blank"
                                            }, label);
                                } else {
                                  return label;
                                }
                            
                          }
                      
                    }
                  });
      }), propsAreSame);

exports.propsAreSame = propsAreSame;
exports.make = make;
/* make Not a pure module */
